module.exports = __webpack_public_path__ + "static/media/kelal_web.9042cbcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/websitesAndProjects/kelal_web.jpg
// module id = 88
// module chunks = 0